import { toJSON, fromJSON } from 'app/infrastructure/platform/json';
import { clientInfo } from 'app/infrastructure/log/client-info';
import * as React from 'react';
import styles from './fallback.scss';

const JsonTree: any = require('react-editable-json-tree').JsonTree;

/**
 * Property panel displays details about the selected UI components configuration
 */
export class PropertyPanel extends React.PureComponent<any, any>{
  private exportProps: any = null;
  public state: Readonly<any> = {};

  /**
   * Allow user to copy config to clipboard
   */
  public copy = () => {

    // error objects cannot be serialized to JSON without deconstructing them first
    const error = this.props.$inspectedError && fromJSON(toJSON(this.props.$inspectedError));

    const textField = document.createElement('textarea');
    textField.value = toJSON({ ...this.exportProps, error, clientInfo: clientInfo() }, 4);
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
  }

  public updatePreview = (props: any) => {
    if (this.props.onUpdatePreview) {
      this.props.onUpdatePreview(props);
    }
  }

  private prepare = (data: any) => {

    const {
      ...cloned
      } = data;

    if (!cloned.value) {
      // prevent react uncontrolled
      cloned.value = null;
    }

    Object.keys(cloned).forEach((prop: string) => {
      if (typeof cloned[prop] === 'function') {
        cloned[prop] = data[prop].toString().substr(0, 50) + '...';
      }
    });
    return cloned;
  }

  private isNodeReadOnly = (key: string, data: any, path: string[], depth: number, type: string) => {
    return type === 'function' ||
      ['children',
        'sequence',
        'componentId',
        'resolveContext',
        'loadOptions',
        'formatter',
        'formatters'].indexOf(key) >= 0;
  }

  public render() {

    // Since this is'nt a end-user feature we allow inner html
    // tslint:disable react-no-dangerous-html

    const { config, properties } = this.props.componentDescriptor;
    const { ...runtimeProps } = this.props;
    this.exportProps = { config, properties, runtimeProps };

    return <div className="card" style={{ padding: 0, color: '#000' }}>

      <ul className={`list-group ${styles.scrollableParent}`} >
        <div style={{ display: 'inline-block' }}>
          <a href="#" onClick={this.copy} className="pull-right" title="Copy">Copy to clipboard</a>
        </div>
        <div className={`${styles.scrollable}`}>
          <div className="card" style={{ padding: 0 }}>
            <div className="card-header">
              Server Configuration
          </div>
            <div className="card-block">
              <JsonTree readOnly={true} data={config} />
            </div>
          </div>

          <div className="card" style={{ padding: 0 }}>
            <div className="card-header">
              Component Configuration
          </div>
            <div className="card-block">
              <JsonTree readOnly={true} data={properties} />
            </div>
          </div>

          <div className="card" style={{ padding: 0 }}>
            <div className="card-header">
              Component Props
            </div>
            <div className="card-block">
              <JsonTree
                data={this.prepare(runtimeProps)}
                readOnly={this.isNodeReadOnly}
                style={{ color: 'black' }}
                onFullyUpdate={this.updatePreview}
              />
            </div>
          </div>
        </div>
      </ul>
    </div>;
  }
}
